export const QUOTATION = {
  successEmail: 'Email enviado con éxito',
  errorEmail: 'Error al intentar enviar la confirmación por correo',
};
